import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'enumerate'
})
export class NumberToArrayPipe implements PipeTransform {

  transform(value: number, reversed: boolean = false): any {
    let res = [];
    for (let i = 0; i < value; i++) {
      res.push(i);
    }
    if (reversed) {
      res.reverse();
    }
    return res;
  }

}
